import Vue from "vue";
import Vuex from "vuex";

import { customerModule } from "@/store/modules/customer";
import { filtersModule } from "@/store/modules/filters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    customer: customerModule,
    filters: filtersModule
  }
});
